import { Input } from './input'
import { Label } from './label'
import { Button } from './button'
import { Select_simple } from './select_simple'
import { LoadingModal } from './LoadingModal'
//import DocumentList from './DocumentList'

export {
    Input,
    Label,
    Button,
    Select_simple,
    LoadingModal,
    //DocumentList    
}